export function getEmptyStateMsaMap(emptyStateResources, darkMode, isDesktopApp) {
    var emptyStateMap = new Map([
        [
            'all',
            {
                zeroExperienceTitle: emptyStateResources.allEmptyStateMsaTitle,
                zeroExperienceSubtitle: emptyStateResources.allEmptyStateMsaSubtitle,
                imageName: darkMode ? 'chair_dark' : 'chair_light',
            },
        ],
        [
            'recent',
            {
                zeroExperienceTitle: emptyStateResources.allEmptyStateMsaTitle,
                zeroExperienceSubtitle: emptyStateResources.allEmptyStateMsaSubtitle,
                imageName: darkMode ? 'chair_dark' : 'chair_light',
            },
        ],
        [
            'shared',
            {
                zeroExperienceTitle: emptyStateResources.noSharedMsaTitle,
                zeroExperienceSubtitle: emptyStateResources.noSharedMsaSubtitle,
                imageName: darkMode ? 'people_dark_msa' : 'people_light_msa',
            },
        ],
        [
            'favorites',
            {
                zeroExperienceTitle: emptyStateResources.noFavoritesMsaTitle,
                zeroExperienceSubtitle: emptyStateResources.noFavoritesMsaSubtitle,
                imageName: darkMode
                    ? 'favorites_dark_msa'
                    : 'favorites_light_msa',
            },
        ],
        [
            'attachments',
            {
                zeroExperienceTitle: emptyStateResources.attachmentsEmptyStateTitle,
                zeroExperienceSubtitle: emptyStateResources.attachmentsEmptyStateMsaSubtitle,
                imageName: darkMode
                    ? 'attachments_dark_msa'
                    : 'attachments_light_msa',
            },
        ],
        [
            'filter',
            {
                zeroExperienceSubtitle: emptyStateResources.noFilterResultsSubtitle,
                imageName: darkMode ? 'search_dark_msa' : 'search_light_msa',
            },
        ],
        [
            'error',
            {
                zeroExperienceTitle: emptyStateResources.errorStateTitle,
                zeroExperienceSubtitle: isDesktopApp
                    ? emptyStateResources.errorStateSubtitleDesktop
                    : emptyStateResources.errorStateSubtitle,
                imageName: darkMode ? 'error_dark' : 'error_light',
            },
        ],
        [
            'createdByMe',
            {
                zeroExperienceTitle: emptyStateResources.createdByMeEmptyStateTitle,
                zeroExperienceSubtitle: emptyStateResources.createdByMeEmptyStateSubtitle,
                imageName: darkMode ? 'all_dark' : 'all_light',
            },
        ],
        [
            'meetingRecordings',
            {
                zeroExperienceTitle: emptyStateResources.meetingRecordingEmptyStateTitle,
                zeroExperienceSubtitle: emptyStateResources.meetingRecordingEmptyStateSubtitle,
                imageName: darkMode ? 'meetings_dark' : 'meetings_light',
            },
        ],
        [
            'playlists',
            {
                zeroExperienceTitle: emptyStateResources.playlistEmptyStateTitle,
                zeroExperienceSubtitle: emptyStateResources.playlistEmptyStateSubtitle,
                imageName: darkMode ? 'empty_state_dark' : 'empty_state_light',
            },
        ],
    ]);
    return emptyStateMap;
}
//# sourceMappingURL=getEmptyStateMsaMap.js.map